// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"27":"f42064f8","41":"10101e86","740":"fac55acd"}[chunkId] + ".js";
};